import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import DownDerateTrackerPage from "pages/DownDerateTrackerPage";

export const DownDerateRoutes = (): JSX.Element => {
  return (
    <Switch>
      <Route exact path="/pages/down-derate-tracker">
        <DownDerateTrackerPage />
      </Route>

      {/* Redirect to the closest exact path above when an incorrect url is entered*/}
      <Redirect
        to="/pages/down-derate-tracker"
        from="/pages/down-derate-tracker"
      />
      <Redirect to="/pages" />
    </Switch>
  );
};
